import * as React from "react";
import { useEffect, useImperativeHandle, useState } from "react";
import { useFormikContext } from "formik";
import { Input } from "components/bootstrap";
import { FormikFormGroup, TimeUnitInput } from "components/common";
import { getValueFromInput } from "util/FormsUtils";
const CaffeineCacheFieldSet = ({ config }, ref) => {
  var _a;
  const { values, setValues, errors } = useFormikContext();
  const [stateConfig, setStateConfig] = useState({ ...config });
  useEffect(() => setStateConfig({ ...config }), [config]);
  const validateConfig = () => {
    const configErrors = {};
    if (!values.config.max_size) configErrors.max_size = "Required";
    if (values.config.max_size < 0) configErrors.max_size = "Must be 0 or a positive number";
    return configErrors;
  };
  useImperativeHandle(ref, () => ({
    validate: () => validateConfig()
  }));
  const handleIgnoreNullChange = (event) => {
    const ignoreValue = getValueFromInput(event.target);
    const valConfig = { ...values.config, ignore_null: ignoreValue };
    setStateConfig(valConfig);
    setValues({ ...values, config: valConfig });
  };
  const handleUpdate = (name) => (value, unit, enabled) => {
    const auxConfig = { ...stateConfig };
    const auxValConfig = { ...values.config };
    auxConfig[name] = enabled ? value : 0;
    auxConfig[`${name}_unit`] = unit;
    auxValConfig[name] = enabled ? value : 0;
    auxValConfig[`${name}_unit`] = unit;
    setStateConfig(auxConfig);
    setValues({ ...values, config: auxValConfig });
  };
  return /* @__PURE__ */ React.createElement("fieldset", { ref }, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "config.max_size",
      label: "* Maximum entries",
      required: true,
      help: ((_a = errors.config) == null ? void 0 : _a.max_size) ? null : "The limit of the number of entries the cache keeps in memory.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "Expire after access",
      help: "If enabled, entries are removed from the cache after the specified time from when they were last used.",
      update: handleUpdate("expire_after_access"),
      name: "config.expire_after_access",
      unitName: "config.expire_after_access_unit",
      value: stateConfig.expire_after_access,
      unit: stateConfig.expire_after_access_unit || "SECONDS",
      defaultEnabled: config.expire_after_access > 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "Expire after write",
      help: "If enabled, entries are removed from the cache after the specified time from when they were first used.",
      update: handleUpdate("expire_after_write"),
      name: "config.expire_after_write",
      unitName: "config.expire_after_write_unit",
      value: stateConfig.expire_after_write,
      unit: stateConfig.expire_after_write_unit || "SECONDS",
      defaultEnabled: config.expire_after_write > 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "ignore_null",
      name: "ignore_null",
      label: "Ignore empty results",
      checked: stateConfig.ignore_null,
      onChange: handleIgnoreNullChange,
      help: "When enabled, empty lookup results will be ignored and not cached.",
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "TTL for empty results",
      help: "Empty results are removed from the cache after the specified time.",
      update: handleUpdate("ttl_empty"),
      name: "config.ttl_empty",
      unitName: "config.ttl_empty_unit",
      value: stateConfig.ttl_empty,
      unit: stateConfig.ttl_empty_unit || "SECONDS",
      enabled: !stateConfig.ignore_null,
      hideCheckbox: true,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default React.forwardRef(CaffeineCacheFieldSet);
